const extraEntryTranslations = {
  ur: {
    badgeText: 'آزمائشی اجرا',
    footerNote: 'یہ پورٹل لیبر مقدمات کو محفوظ اور منظم طریقے سے جمع کرنے اور ان کی پیروی کے لیے مخصوص ہے۔',
    pill: 'لیبر مقدمات کا پورٹل',
    title: 'لیبر مقدمات جمع کرانے اور پیروی کرنے کا پورٹل',
    description: 'اس پورٹل کے ذریعے آپ نئی درخواست جمع کر سکتے ہیں، سابقہ درخواست کی حالت دیکھ سکتے ہیں، اور مطلوبہ معلومات و دستاویزات مکمل کر سکتے ہیں۔',
    afterSubmission: 'درخواست جمع ہونے کے بعد کیا ملے گا؟',
    refBenefit: 'درخواست کا مخصوص حوالہ نمبر',
    trackBenefit: 'محفوظ نجی ٹریکنگ لنک',
    reviewBenefit: 'متخصص قانونی ٹیم کا جائزہ',
    trust1: 'درخواستوں کا جائزہ متخصص قانونی ٹیم لیتی ہے۔',
    trust2: 'تمام معلومات اور منسلکات مکمل رازداری سے محفوظ رکھے جاتے ہیں۔',
    trust3: 'لیبر مقدمات جمع کرنے اور ان کی پیروی کے لیے مخصوص پورٹل۔',
    actions: {
      new: { title: 'نئی درخواست جمع کریں', description: 'لیبر مقدمے کی معلومات درج کریں اور متعلقہ دستاویزات منسلک کریں۔', detail: 'منظم مرحلہ وار فارم کے ذریعے نئی درخواست شروع کریں۔', button: 'درخواست شروع کریں' },
      track: { title: 'سابقہ درخواست کی پیروی', description: 'درخواست کی حالت دیکھیں اور مطلوبہ کمی یا دستاویزات مکمل کریں۔', detail: 'وازن ٹیم کے نوٹس دیکھیں اور مطلوبہ اضافی دستاویزات اپ لوڈ کریں۔', button: 'پیروی کھولیں' },
      draft: { title: 'محفوظ درخواست مکمل کریں', description: 'پہلے محفوظ کی گئی غیر جمع شدہ درخواست مکمل کریں۔', detail: 'یہ حصہ صرف غیر جمع شدہ مسودات کے لیے ہے۔', button: 'مسودہ مکمل کریں', resumeButton: 'مسودہ مکمل کریں', savedAt: 'آخری محفوظ وقت' },
    },
  },
  bn: {
    badgeText: 'পরীক্ষামূলক চালু',
    footerNote: 'এই পোর্টালটি শ্রম মামলা নিরাপদ ও সুশৃঙ্খলভাবে জমা এবং অনুসরণের জন্য নির্ধারিত।',
    pill: 'শ্রম মামলা পোর্টাল',
    title: 'শ্রম মামলা জমা ও অনুসরণ পোর্টাল',
    description: 'এই পোর্টালের মাধ্যমে নতুন আবেদন জমা, আগের আবেদনের অবস্থা দেখা এবং প্রয়োজনীয় তথ্য ও নথি পূরণ করা যায়।',
    afterSubmission: 'জমা দেওয়ার পর কী পাবেন?',
    refBenefit: 'আবেদনের নিজস্ব রেফারেন্স নম্বর',
    trackBenefit: 'নিরাপদ ব্যক্তিগত ট্র্যাকিং লিংক',
    reviewBenefit: 'বিশেষজ্ঞ আইন দলের পর্যালোচনা',
    trust1: 'বিশেষজ্ঞ আইন দল আবেদন পর্যালোচনা করে।',
    trust2: 'সব তথ্য ও সংযুক্তি সম্পূর্ণ গোপনীয়ভাবে রাখা হয়।',
    trust3: 'শ্রম মামলা জমা ও অনুসরণের জন্য নির্ধারিত পোর্টাল।',
    actions: {
      new: { title: 'নতুন আবেদন জমা দিন', description: 'শ্রম মামলার তথ্য পূরণ করুন এবং সংশ্লিষ্ট নথি সংযুক্ত করুন।', detail: 'সুশৃঙ্খল ধাপে ধাপে ফর্মে নতুন আবেদন শুরু করুন।', button: 'আবেদন শুরু করুন' },
      track: { title: 'আগের আবেদন অনুসরণ করুন', description: 'আবেদনের অবস্থা দেখুন এবং চাওয়া তথ্য বা নথি পূরণ করুন।', detail: 'ওয়াজিন দলের মন্তব্য দেখুন এবং প্রয়োজনীয় অতিরিক্ত নথি আপলোড করুন।', button: 'ট্র্যাকিং খুলুন' },
      draft: { title: 'সংরক্ষিত আবেদন পূরণ করুন', description: 'আগে সংরক্ষিত কিন্তু জমা না দেওয়া আবেদনটি পূরণ করুন।', detail: 'এই অংশটি শুধু জমা না দেওয়া খসড়ার জন্য।', button: 'খসড়া পূরণ করুন', resumeButton: 'খসড়া পূরণ করুন', savedAt: 'সর্বশেষ সংরক্ষণ' },
    },
  },
  id: {
    badgeText: 'Peluncuran Uji Coba',
    footerNote: 'Portal ini khusus untuk mengajukan dan melacak perkara ketenagakerjaan secara aman dan teratur.',
    pill: 'Portal Perkara Ketenagakerjaan',
    title: 'Portal Pengajuan dan Pelacakan Perkara Ketenagakerjaan',
    description: 'Melalui portal ini Anda dapat mengajukan permohonan baru, melacak permohonan sebelumnya, serta melengkapi data dan dokumen yang diminta.',
    afterSubmission: 'Apa yang Anda terima setelah pengajuan?',
    refBenefit: 'Nomor referensi khusus permohonan',
    trackBenefit: 'Tautan pelacakan pribadi dan aman',
    reviewBenefit: 'Peninjauan oleh tim hukum khusus',
    trust1: 'Permohonan ditinjau oleh tim hukum khusus.',
    trust2: 'Semua data dan lampiran ditangani secara rahasia.',
    trust3: 'Portal khusus pengajuan dan pelacakan perkara ketenagakerjaan.',
    actions: {
      new: { title: 'Ajukan Permohonan Baru', description: 'Lengkapi data dan lampirkan dokumen terkait perkara ketenagakerjaan.', detail: 'Mulai permohonan baru melalui formulir bertahap yang terstruktur.', button: 'Mulai Permohonan' },
      track: { title: 'Lacak Permohonan Sebelumnya', description: 'Lacak status permohonan dan lengkapi kekurangan data atau dokumen.', detail: 'Tinjau catatan tim Wazin dan unggah dokumen tambahan yang diminta.', button: 'Buka Pelacakan' },
      draft: { title: 'Lanjutkan Permohonan Tersimpan', description: 'Lanjutkan permohonan yang disimpan dan belum dikirim.', detail: 'Bagian ini khusus untuk draf yang belum dikirim.', button: 'Lanjutkan Draf', resumeButton: 'Lanjutkan Draf', savedAt: 'Terakhir disimpan' },
    },
  },
  ml: {
    badgeText: 'പരീക്ഷണാടിസ്ഥാനത്തിലുള്ള ആരംഭം',
    footerNote: 'തൊഴിൽ കേസുകൾ സുരക്ഷിതമായും ക്രമബദ്ധമായും സമർപ്പിക്കാനും പിന്തുടരാനും ഈ പോർട്ടൽ ഉപയോഗിക്കാം.',
    pill: 'തൊഴിൽ കേസുകളുടെ പോർട്ടൽ',
    title: 'തൊഴിൽ കേസുകൾ സമർപ്പിക്കാനും പിന്തുടരാനുമുള്ള പോർട്ടൽ',
    description: 'ഈ പോർട്ടലിലൂടെ പുതിയ അപേക്ഷ സമർപ്പിക്കാനും മുൻ അപേക്ഷയുടെ നില പരിശോധിക്കാനും ആവശ്യമായ വിവരങ്ങളും രേഖകളും പൂർത്തിയാക്കാനും കഴിയും.',
    afterSubmission: 'അപേക്ഷ സമർപ്പിച്ചതിന് ശേഷം ലഭിക്കുന്നത്',
    refBenefit: 'അപേക്ഷയ്ക്കുള്ള പ്രത്യേക റഫറൻസ് നമ്പർ',
    trackBenefit: 'സുരക്ഷിതമായ സ്വകാര്യ ട്രാക്കിംഗ് ലിങ്ക്',
    reviewBenefit: 'വിദഗ്ധ നിയമസംഘത്തിന്റെ പരിശോധന',
    trust1: 'അപേക്ഷകൾ വിദഗ്ധ നിയമസംഘം പരിശോധിക്കുന്നു.',
    trust2: 'എല്ലാ വിവരങ്ങളും അനുബന്ധ രേഖകളും പൂർണ്ണ രഹസ്യമായി കൈകാര്യം ചെയ്യുന്നു.',
    trust3: 'തൊഴിൽ കേസുകൾ സമർപ്പിക്കാനും പിന്തുടരാനുമുള്ള പ്രത്യേക പോർട്ടൽ.',
    actions: {
      new: {
        title: 'പുതിയ അപേക്ഷ സമർപ്പിക്കുക',
        description: 'തൊഴിൽ കേസുമായി ബന്ധപ്പെട്ട വിവരങ്ങൾ പൂരിപ്പിച്ച് രേഖകൾ ചേർക്കുക.',
        detail: 'ക്രമബദ്ധമായ ഘട്ടംഘട്ടമായ ഫോമിലൂടെ പുതിയ അപേക്ഷ ആരംഭിക്കുക.',
        button: 'അപേക്ഷ ആരംഭിക്കുക',
      },
      track: {
        title: 'മുൻ അപേക്ഷ പിന്തുടരുക',
        description: 'അപേക്ഷയുടെ നില പരിശോധിച്ച് ആവശ്യപ്പെട്ട വിവരങ്ങളും രേഖകളും പൂർത്തിയാക്കുക.',
        detail: 'വാസിൻ സംഘത്തിന്റെ കുറിപ്പുകൾ പരിശോധിച്ച് ആവശ്യമായ അധിക രേഖകൾ അപ്‌ലോഡ് ചെയ്യുക.',
        button: 'ട്രാക്കിംഗ് തുറക്കുക',
      },
      draft: {
        title: 'സംരക്ഷിച്ച അപേക്ഷ പൂർത്തിയാക്കുക',
        description: 'മുമ്പ് സംരക്ഷിച്ചെങ്കിലും സമർപ്പിക്കാത്ത അപേക്ഷ തുടരുക.',
        detail: 'ഈ ഭാഗം സമർപ്പിക്കാത്ത കരടുകൾക്കായി മാത്രം.',
        button: 'കരട് തുടരുക',
        resumeButton: 'കരട് തുടരുക',
        savedAt: 'അവസാനം സംരക്ഷിച്ചത്',
      },
    },
  },
  tl: {
    badgeText: 'Paunang Paglulunsad',
    footerNote: 'Ang portal na ito ay para sa ligtas at maayos na pagsusumite at pagsubaybay ng mga kaso sa paggawa.',
    pill: 'Portal ng mga Kaso sa Paggawa',
    title: 'Portal para sa Pagsusumite at Pagsubaybay ng mga Kaso sa Paggawa',
    description: 'Sa portal na ito, maaari kang magsumite ng bagong kahilingan, subaybayan ang naunang kahilingan, at kumpletuhin ang kinakailangang impormasyon at mga dokumento.',
    afterSubmission: 'Ano ang matatanggap pagkatapos magsumite?',
    refBenefit: 'Natatanging reference number ng kahilingan',
    trackBenefit: 'Ligtas at pribadong tracking link',
    reviewBenefit: 'Pagsusuri ng dalubhasang legal team',
    trust1: 'Sinusuri ng dalubhasang legal team ang mga kahilingan.',
    trust2: 'Ang lahat ng impormasyon at kalakip ay pinangangasiwaan nang lubos na kumpidensyal.',
    trust3: 'Portal na nakalaan para sa pagsusumite at pagsubaybay ng mga kaso sa paggawa.',
    actions: {
      new: {
        title: 'Magsumite ng Bagong Kahilingan',
        description: 'Kumpletuhin ang impormasyon at ilakip ang mga dokumentong may kaugnayan sa kaso sa paggawa.',
        detail: 'Magsimula ng bagong kahilingan gamit ang maayos na sunud-sunod na form.',
        button: 'Simulan ang Kahilingan',
      },
      track: {
        title: 'Subaybayan ang Naunang Kahilingan',
        description: 'Subaybayan ang kalagayan at kumpletuhin ang hinihinging impormasyon o mga dokumento.',
        detail: 'Tingnan ang mga tala ng Wazin team at i-upload ang mga karagdagang dokumentong hinihingi.',
        button: 'Buksan ang Pagsubaybay',
      },
      draft: {
        title: 'Ipagpatuloy ang Naka-save na Kahilingan',
        description: 'Ipagpatuloy ang kahilingang na-save ngunit hindi pa naisusumite.',
        detail: 'Ang bahaging ito ay para lamang sa mga draft na hindi pa naisusumite.',
        button: 'Ipagpatuloy ang Draft',
        resumeButton: 'Ipagpatuloy ang Draft',
        savedAt: 'Huling na-save',
      },
    },
  },
};

export const getLaborPortalCopy = (languageOrIsArabic = 'ar') => {
  const language = typeof languageOrIsArabic === 'boolean'
    ? (languageOrIsArabic ? 'ar' : 'en')
    : languageOrIsArabic;

  if (extraEntryTranslations[language]) {
    return { entry: extraEntryTranslations[language] };
  }

  const isArabic = language === 'ar';
  return {
  entry: isArabic
    ? {
        badgeText: 'إطلاق تجريبي',
        footerNote: 'هذه البوابة مخصصة لتقديم القضايا العمالية ومتابعتها بشكل منظم وآمن.',
        pill: 'بوابة القضايا العمالية',
        title: 'بوابة تقديم ومتابعة القضايا العمالية',
        description:
          'يمكنكم من خلال هذه البوابة تقديم الطلبات العمالية، متابعة الحالات السابقة، واستكمال البيانات والمستندات المطلوبة ضمن مسار منظم وواضح.',
        afterSubmission: 'ماذا ستحصلون بعد الإرسال؟',
        refBenefit: 'رقم مرجعي خاص بالطلب',
        trackBenefit: 'رابط متابعة مستقل وآمن',
        reviewBenefit: 'مراجعة من الفريق القانوني المختص',
        trust1: 'تتم مراجعة الطلبات من قبل الفريق القانوني المختص.',
        trust2: 'جميع البيانات والمرفقات تعامل بسرية تامة.',
        trust3: 'بوابة مخصصة لتقديم ومتابعة القضايا العمالية.',
        actions: {
          new: {
            title: 'تقديم طلب جديد',
            description: 'تعبئة البيانات وإرفاق المستندات المتعلقة بالقضية العمالية.',
            detail: 'بدء طلب جديد عبر نموذج منظم متعدد الخطوات.',
            button: 'بدء الطلب',
          },
          track: {
            title: 'متابعة طلب سابق',
            description: 'متابعة حالة الطلب واستكمال النواقص والمستندات المطلوبة.',
            detail: 'مراجعة ملاحظات فريق وازن ورفع المستندات الإضافية عند طلبها.',
            button: 'فتح المتابعة',
          },
          draft: {
            title: 'استكمال طلب',
            description: 'استكمال طلب محفوظ سابقاً لم يتم إرساله بعد.',
            detail: 'هذه البطاقة مخصصة للمسودات غير المرسلة فقط.',
            button: 'استكمال المسودة',
            resumeButton: 'استكمال المسودة',
            savedAt: 'آخر حفظ',
          },
        },
      }
    : {
        badgeText: 'Pilot Launch',
        footerNote: 'This portal is dedicated to submitting and tracking labor cases in a secure, organized manner.',
        pill: 'Labor Cases Portal',
        title: 'Labor Case Submission and Tracking Portal',
        description:
          'Through this portal, you can submit labor requests, track previous cases, and complete the required information and supporting documents through a clear and organized process.',
        afterSubmission: 'What will you receive after submission?',
        refBenefit: 'A dedicated reference number',
        trackBenefit: 'A secure private tracking link',
        reviewBenefit: 'Review by the specialized legal team',
        trust1: 'Requests are reviewed by the specialized legal team.',
        trust2: 'All data and attachments are handled confidentially.',
        trust3: 'A dedicated portal for labor case submission and tracking.',
        actions: {
          new: {
            title: 'Submit a New Request',
            description: 'Complete the form and attach documents related to the labor case.',
            detail: 'Start a new request through a structured multi-step form.',
            button: 'Start Request',
          },
          track: {
            title: 'Track a Previous Request',
            description: 'Track the request status and complete any requested missing items or documents.',
            detail: 'Review Wazin team notes and upload additional documents when requested.',
            button: 'Open Tracking',
          },
          draft: {
            title: 'Complete a Saved Request',
            description: 'Resume a previously saved request that has not been submitted yet.',
            detail: 'This card is dedicated to unsubmitted drafts only.',
            button: 'Resume Draft',
            resumeButton: 'Resume Draft',
            savedAt: 'Last saved',
          },
        },
      },
  };
};

export const laborStepsEn = {
  client: { title: 'Client Details', description: 'Basic information for communication and linking the request to its owner.' },
  company: { title: 'Employer Details', description: 'Information about the employer or company involved in the dispute.' },
  contract: { title: 'Contract and Relationship', description: 'Contract details, start date, and the current or ended relationship status.' },
  employment: { title: 'Employment Relationship, Wage, and Entitlements Analysis', description: 'Analyze the actual relationship, wage structure, leave, overtime, and core financial claims.' },
  notices: { title: 'Termination and Claims', description: 'Termination details, dispute correspondence, and the claims reported by the applicant.' },
  summary: { title: 'Summary of Data and Facts', description: 'An organized summary of the submitted data and facts before confirmation.' },
  attachments: { title: 'Attachments', description: 'Upload and organize the supporting documents related to the request.' },
  declaration: { title: 'Final Declaration and Submission', description: 'Final declaration of accuracy and approval to submit the request.' },
};

export const laborStepTitlesByLanguage = {
  ur: {
    client: 'کلائنٹ کی معلومات',
    company: 'ادارے کی معلومات',
    contract: 'معاہدہ اور تعلق',
    employment: 'ملازمت اور اجرت',
    notices: 'اختتام اور مطالبات',
    summary: 'حقائق کا خلاصہ',
    attachments: 'منسلکات',
    declaration: 'اقرار اور ارسال',
  },
  bn: {
    client: 'ক্লায়েন্টের তথ্য',
    company: 'প্রতিষ্ঠানের তথ্য',
    contract: 'চুক্তি ও সম্পর্ক',
    employment: 'কর্মসম্পর্ক ও মজুরি',
    notices: 'সমাপ্তি ও দাবি',
    summary: 'ঘটনার সারসংক্ষেপ',
    attachments: 'সংযুক্তি',
    declaration: 'ঘোষণা ও জমা',
  },
  id: {
    client: 'Data Klien',
    company: 'Data Pemberi Kerja',
    contract: 'Kontrak dan Hubungan',
    employment: 'Hubungan dan Upah',
    notices: 'Berakhirnya Hubungan dan Tuntutan',
    summary: 'Ringkasan Fakta',
    attachments: 'Lampiran',
    declaration: 'Pernyataan dan Pengiriman',
  },
  ml: {
    client: 'ക്ലയന്റിന്റെ വിവരങ്ങൾ',
    company: 'സ്ഥാപനത്തിന്റെ വിവരങ്ങൾ',
    contract: 'കരാറും തൊഴിൽബന്ധവും',
    employment: 'തൊഴിൽബന്ധവും വേതനവും',
    notices: 'ബന്ധം അവസാനിപ്പിക്കലും ആവശ്യങ്ങളും',
    summary: 'വസ്തുതകളുടെ സംഗ്രഹം',
    attachments: 'അനുബന്ധ രേഖകൾ',
    declaration: 'പ്രഖ്യാപനവും സമർപ്പണവും',
  },
  tl: {
    client: 'Impormasyon ng Kliyente',
    company: 'Impormasyon ng Employer',
    contract: 'Kontrata at Ugnayan',
    employment: 'Ugnayan sa Trabaho at Sahod',
    notices: 'Pagtatapos at mga Kahilingan',
    summary: 'Buod ng mga Pangyayari',
    attachments: 'Mga Kalakip',
    declaration: 'Pahayag at Pagsusumite',
  },
};

export const laborCommonOptionsByLanguage = {
  ur: {
    'نعم': 'ہاں', 'لا': 'نہیں', 'لا أعلم': 'معلوم نہیں', 'أخرى': 'دیگر',
    'جزئياً': 'جزوی طور پر', 'أحياناً': 'کبھی کبھار', 'جديدة': 'نئی', 'مستعملة': 'استعمال شدہ',
    'تحويل بنكي': 'بینک ٹرانسفر', 'نقداً': 'نقد', 'شيك': 'چیک', 'شيكات': 'چیکس',
    'خصم من الراتب': 'اجرت سے کٹوتی', 'أكثر من طريقة': 'ایک سے زیادہ طریقے',
    'استقالة': 'استعفیٰ', 'إنهاء باتفاق الطرفين': 'باہمی رضامندی سے اختتام',
    'فسخ العقد بموجب المادة 80': 'دفعہ 80 کے تحت معاہدہ ختم',
    'فسخ العقد بموجب المادة 81': 'دفعہ 81 کے تحت معاہدہ ختم',
    'جهاز حاسب': 'کمپیوٹر', 'جوال': 'موبائل فون', 'سيارة': 'گاڑی', 'معدات': 'آلات',
    'أدوات عمل': 'کام کے اوزار', 'مبالغ نقدية': 'نقد رقم',
  },
  bn: {
    'نعم': 'হ্যাঁ', 'لا': 'না', 'لا أعلم': 'জানি না', 'أخرى': 'অন্যান্য',
    'جزئياً': 'আংশিক', 'أحياناً': 'কখনও কখনও', 'جديدة': 'নতুন', 'مستعملة': 'ব্যবহৃত',
    'تحويل بنكي': 'ব্যাংক ট্রান্সফার', 'نقداً': 'নগদ', 'شيك': 'চেক', 'شيكات': 'চেক',
    'خصم من الراتب': 'মজুরি থেকে কর্তন', 'أكثر من طريقة': 'একাধিক পদ্ধতি',
    'استقالة': 'পদত্যাগ', 'إنهاء باتفاق الطرفين': 'উভয় পক্ষের সম্মতিতে সমাপ্তি',
    'فسخ العقد بموجب المادة 80': 'ধারা ৮০ অনুযায়ী চুক্তি বাতিল',
    'فسخ العقد بموجب المادة 81': 'ধারা ৮১ অনুযায়ী চুক্তি বাতিল',
    'جهاز حاسب': 'কম্পিউটার', 'جوال': 'মোবাইল ফোন', 'سيارة': 'গাড়ি', 'معدات': 'সরঞ্জাম',
    'أدوات عمل': 'কাজের যন্ত্রপাতি', 'مبالغ نقدية': 'নগদ অর্থ',
  },
  id: {
    'نعم': 'Ya', 'لا': 'Tidak', 'لا أعلم': 'Tidak tahu', 'أخرى': 'Lainnya',
    'جزئياً': 'Sebagian', 'أحياناً': 'Kadang-kadang', 'جديدة': 'Baru', 'مستعملة': 'Bekas',
    'تحويل بنكي': 'Transfer bank', 'نقداً': 'Tunai', 'شيك': 'Cek', 'شيكات': 'Cek',
    'خصم من الراتب': 'Potongan upah', 'أكثر من طريقة': 'Lebih dari satu cara',
    'استقالة': 'Mengundurkan diri', 'إنهاء باتفاق الطرفين': 'Berakhir atas kesepakatan kedua pihak',
    'فسخ العقد بموجب المادة 80': 'Pemutusan berdasarkan Pasal 80',
    'فسخ العقد بموجب المادة 81': 'Pemutusan berdasarkan Pasal 81',
    'جهاز حاسب': 'Komputer', 'جوال': 'Telepon seluler', 'سيارة': 'Mobil', 'معدات': 'Peralatan',
    'أدوات عمل': 'Perlengkapan kerja', 'مبالغ نقدية': 'Uang tunai',
  },
  ml: {
    'نعم': 'അതെ', 'لا': 'ഇല്ല', 'لا أعلم': 'അറിയില്ല', 'أخرى': 'മറ്റുള്ളവ',
    'جزئياً': 'ഭാഗികമായി', 'أحياناً': 'ചിലപ്പോൾ', 'جديدة': 'പുതിയത്', 'مستعملة': 'ഉപയോഗിച്ചത്',
    'تحويل بنكي': 'ബാങ്ക് ട്രാൻസ്ഫർ', 'نقداً': 'പണമായി', 'شيك': 'ചെക്ക്', 'شيكات': 'ചെക്കുകൾ',
    'خصم من الراتب': 'വേതനത്തിൽ നിന്ന് കുറവ്', 'أكثر من طريقة': 'ഒന്നിലധികം മാർഗങ്ങൾ',
    'استقالة': 'രാജി', 'إنهاء باتفاق الطرفين': 'ഇരുപാർട്ടികളുടെയും സമ്മതപ്രകാരം അവസാനിപ്പിക്കൽ',
    'فسخ العقد بموجب المادة 80': 'ആർട്ടിക്കിൾ 80 പ്രകാരം കരാർ അവസാനിപ്പിക്കൽ',
    'فسخ العقد بموجب المادة 81': 'ആർട്ടിക്കിൾ 81 പ്രകാരം കരാർ അവസാനിപ്പിക്കൽ',
    'جهاز حاسب': 'കമ്പ്യൂട്ടർ', 'جوال': 'മൊബൈൽ ഫോൺ', 'سيارة': 'വാഹനം', 'معدات': 'ഉപകരണങ്ങൾ',
    'أدوات عمل': 'ജോലി ഉപകരണങ്ങൾ', 'مبالغ نقدية': 'പണം',
  },
  tl: {
    'نعم': 'Oo', 'لا': 'Hindi', 'لا أعلم': 'Hindi ko alam', 'أخرى': 'Iba pa',
    'جزئياً': 'Bahagya', 'أحياناً': 'Paminsan-minsan', 'جديدة': 'Bago', 'مستعملة': 'Nagamit na',
    'تحويل بنكي': 'Bank transfer', 'نقداً': 'Cash', 'شيك': 'Tseke', 'شيكات': 'Mga tseke',
    'خصم من الراتب': 'Bawas sa sahod', 'أكثر من طريقة': 'Higit sa isang paraan',
    'استقالة': 'Pagbibitiw', 'إنهاء باتفاق الطرفين': 'Pagtatapos sa kasunduan ng magkabilang panig',
    'فسخ العقد بموجب المادة 80': 'Pagwawakas ayon sa Artikulo 80',
    'فسخ العقد بموجب المادة 81': 'Pagwawakas ayon sa Artikulo 81',
    'جهاز حاسب': 'Computer', 'جوال': 'Mobile phone', 'سيارة': 'Sasakyan', 'معدات': 'Kagamitan',
    'أدوات عمل': 'Mga gamit sa trabaho', 'مبالغ نقدية': 'Halagang cash',
  },
};

export const laborOptionMapsEn = {
  claims: {
    'أجور متأخرة': 'Delayed wages',
    'مكافأة نهاية خدمة': 'End-of-service award',
    'بدل إجازات': 'Unused leave compensation',
    'فصل تعسفي': 'Unfair dismissal',
    'عمولات': 'Commissions',
    'ساعات إضافية': 'Overtime pay',
    'بدل إنذار': 'Notice compensation',
    'شهادة الخدمة': 'Service certificate',
    'رصيد إجازات': 'Leave balance',
    'التعويض عن الأضرار': 'Compensation for damages',
    'تعويض فصل': 'Dismissal compensation',
    'بدل إشعار': 'Notice pay',
    'تذاكر': 'Tickets',
    'تعويض عن فصل غير مشروع': 'Compensation for unlawful dismissal',
    'بدل تذاكر': 'Ticket allowance',
    'بدل سكن': 'Housing allowance',
    'بدل نقل': 'Transport allowance',
    'بدل انتداب': 'Assignment allowance',
    'فروقات أجور': 'Wage differences',
    'إخلاء طرف': 'Clearance letter',
    'أخرى': 'Other',
  },
  evidence: {
    'إشعارات الفصل أو الإنهاء': 'Termination or dismissal notices',
    'رسائل واتساب': 'WhatsApp messages',
    'رسائل بريد إلكتروني': 'Email messages',
    'مسيرات رواتب': 'Payroll sheets',
    'كشف حساب بنكي': 'Bank statement',
    'خطابات أو تعاميم داخلية': 'Internal letters or circulars',
    'تكليفات عمل': 'Work assignments',
    'جداول دوام': 'Work schedules',
    'إثبات حضور وانصراف': 'Attendance and departure proof',
    'تسجيلات أو محادثات': 'Recordings or conversations',
    'عقود أو ملاحق': 'Contracts or addenda',
    'مخالفات أو جزاءات': 'Violations or penalties',
    'تقييمات أداء': 'Performance evaluations',
    'شهود': 'Witnesses',
    'صور أو مقاطع': 'Photos or videos',
    'مراسلات الموارد البشرية': 'HR correspondence',
    'أخرى': 'Other',
  },
  indicators: {
    'ساعات عمل محددة': 'Fixed working hours',
    'دوام حضور وانصراف': 'Attendance and departure schedule',
    'مدير مباشر': 'Direct manager',
    'تعليمات يومية': 'Daily instructions',
    'إجازات بموافقة': 'Leave subject to approval',
    'استخدام أدوات المنشأة': 'Use of employer tools',
    'بريد أو هوية وظيفية': 'Company email or ID',
    'راتب شهري ثابت': 'Fixed monthly salary',
    'جزاءات أو إنذارات': 'Penalties or warnings',
  },
  notices: {
    'إنذار': 'Warning notice',
    'لفت نظر': 'Written notice',
    'قرار فصل': 'Termination decision',
    'إشعار عدم تجديد': 'Non-renewal notice',
    'استدعاء تحقيق': 'Investigation summons',
    'محضر تحقيق': 'Investigation report',
    'قرار خصم': 'Deduction decision',
    'مخالصة': 'Settlement release',
    'إخلاء طرف': 'Clearance letter',
    'إيميل رسمي': 'Official email',
    'رسائل واتساب': 'WhatsApp messages',
    'إشعار قوى أو تأمينات': 'Qiwa or GOSI notice',
  },
  select: {
    'عقد عمل': 'Employment contract',
    'عقد تعاون': 'Cooperation contract',
    'عمل جزئي': 'Part-time work',
    'عمل بالعمولة': 'Commission-based work',
    'تدريب': 'Training',
    'Freelancer / مستقل': 'Freelancer / Independent contractor',
    'بدون عقد مكتوب': 'No written contract',
    'لا أعلم': 'Not sure',
    'نعم': 'Yes',
    'لا': 'No',
    'قائمة': 'Active',
    'منتهية': 'Ended',
    'فصل': 'Dismissal',
    'استقالة': 'Resignation',
    'إنهاء باتفاق الطرفين': 'Termination by mutual agreement',
    'فسخ العقد بموجب المادة 80': 'Termination under Article 80',
    'فسخ العقد بموجب المادة 81': 'Termination under Article 81',
    'انتهاء عقد': 'Contract expiry',
    'عدم تجديد': 'Non-renewal',
    'ترك العمل بسبب عدم السداد': 'Left work due to non-payment',
    'ترك عمل': 'Leaving work',
    'إنهاء من الشركة': 'Termination by employer',
    'إغلاق المنشأة': 'Closure of the establishment',
    'اتفاق بين الطرفين': 'Mutual agreement',
    'ما زالت العلاقة قائمة': 'Relationship still active',
    'تحويل بنكي': 'Bank transfer',
    'نقداً': 'Cash',
    'جزء بنكي وجزء نقدي': 'Part bank / part cash',
    'لا يوجد راتب ثابت': 'No fixed salary',
    'شيكات': 'Cheques',
    'ورقي': 'Paper',
    'بريد إلكتروني': 'Email',
    'واتساب': 'WhatsApp',
    'خطاب رسمي': 'Formal letter',
    'منصة قوى': 'Qiwa platform',
    'منصة ودّي': 'Waddi platform',
    'مكتب العمل': 'Labor Office',
    'رسالة واتساب': 'WhatsApp message',
    'رسالة نصية': 'Text message',
    'داخل النظام': 'Inside the system',
    'شفهي': 'Verbal',
    'بعد استلام المستحقات': 'After receiving dues',
    'قبل استلام المستحقات': 'Before receiving dues',
    'جزء قبل وجزء بعد': 'Part before and part after',
    'ورقية': 'Paper-based',
    'إلكترونية': 'Electronic',
    'كلاهما': 'Both',
    'الرقم الوطني الموحد': 'Unified national number',
    'السجل التجاري': 'Commercial registration',
    'رقم وطني موحد': 'Unified national number',
    'سجل تجاري': 'Commercial registration',
    'ترخيص نشاط': 'Business license',
    'ترخيص مهني': 'Professional license',
    'شهادة استثمار': 'Investment certificate',
    'رقم منشأة التأمينات': 'GOSI establishment number',
    'رقم منشأة مكتب العمل': 'Labor office establishment number',
    'دوام كامل حضوري': 'Full-time onsite',
    'دوام جزئي': 'Part-time',
    'عمل مرن': 'Flexible work',
    'عمل عن بعد': 'Remote work',
    'شفتات': 'Shift work',
    'غير منتظم': 'Irregular schedule',
    'حضوري': 'Onsite',
    'عن بعد': 'Remote',
    'مختلط': 'Hybrid',
    'هجين': 'Hybrid',
    'جزئياً': 'Partially',
    'أحياناً': 'Sometimes',
    'إلى حد ما': 'To some extent',
    'مكتوبة': 'Written',
    'شفوية': 'Verbal',
    'أجر أساسي فقط': 'Basic wage only',
    'أجر شامل': 'Comprehensive wage',
    'أجر أساسي + بدلات': 'Basic wage + allowances',
    'بدل انتقال': 'Mobility allowance',
    'بدل اتصال': 'Communication allowance',
    'بدل طبيعة عمل': 'Nature-of-work allowance',
    'علاوة سنوية': 'Annual increment',
    'مكافآت دورية': 'Periodic bonuses',
    'عادية': 'Normal',
    'مرتفعة': 'High',
    'عاجلة جداً': 'Very urgent',
    'لا أذكر': 'I do not remember',
  },
};
